
function initSliders()
{
    $('.slider').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        dots: true,
        useTransform: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });

    // Stop youtube video when clicking on slide change
    $('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var player, command;

        command = {
            "event": "command",
            "func": "pauseVideo"
        };

        $('.slider .slider-item iframe').each(function () {

            player = $(this).get(0);

            if (player != undefined) {
                player.contentWindow.postMessage(JSON.stringify(command), "*");
            }

        });
    });


    // Stop youtube video when closing carousel modal
    $('.slider-carousel').on('hide.bs.modal', function (event, slick, currentSlide, nextSlide) {
        var player, command;

        command = {
            "event": "command",
            "func": "pauseVideo"
        };

        $('.slider-carousel .carousel-item iframe').each(function () {

            player = $(this).get(0);

            if (player != undefined) {
                player.contentWindow.postMessage(JSON.stringify(command), "*");
            }

        });
    });
}

if (window.jQuery) {
    window.onload = function(e){ 
        initSliders();
    }
}